import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../services/api';
import './InvoiceFormPage.css';

export default function InvoiceFormPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [clients, setClients] = useState([]);
  const [form, setForm]       = useState({
    clientId:    searchParams.get('clientId') || '',
    description: '',
    amountDue:   '',
    dueDate:     '',
  });
  const [errors, setErrors]     = useState({});
  const [saving, setSaving]     = useState(false);
  const [serverError, setServerError] = useState(null);

  useEffect(() => {
    api.get('/clients?active=true').then(data => setClients(data));
  }, []);

  function validate() {
    const e = {};
    if (!form.clientId)                   e.clientId    = 'Select a client.';
    if (!form.description.trim())         e.description = 'Description is required.';
    if (!form.amountDue || isNaN(Number(form.amountDue)) || Number(form.amountDue) <= 0)
                                          e.amountDue   = 'Enter a valid amount.';
    if (!form.dueDate)                    e.dueDate     = 'Due date is required.';
    return e;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setSaving(true);
    setServerError(null);
    try {
      const res = await api.post('/invoices', {
        clientId:    form.clientId,
        description: form.description.trim(),
        amountDue:   Number(form.amountDue),
        dueDate:     new Date(form.dueDate).toISOString(),
      });
      navigate(`/invoices/${res.id}`);
    } catch (err) {
      setServerError(err.message);
    } finally {
      setSaving(false);
    }
  }

  function setField(key, value) {
    setForm(f => ({ ...f, [key]: value }));
    setErrors(er => ({ ...er, [key]: undefined }));
  }

  return (
    <div className="form-page">
      <div className="form-card">
        <h2>New Invoice</h2>
        {serverError && <div className="error-banner">{serverError}</div>}
        <form onSubmit={handleSubmit} noValidate>

          <div className="form-field">
            <label>Client <span className="required">*</span></label>
            <select
              value={form.clientId}
              onChange={e => setField('clientId', e.target.value)}
              className={errors.clientId ? 'input-error' : ''}
            >
              <option value="">— Select a client —</option>
              {clients.map(c => (
                <option key={c.id} value={c.id}>
                  {c.name}{c.company ? ` (${c.company})` : ''}
                </option>
              ))}
            </select>
            {errors.clientId && <span className="field-error">{errors.clientId}</span>}
          </div>

          <div className="form-field">
            <label>Description <span className="required">*</span></label>
            <input
              type="text"
              placeholder="e.g. Monthly Website Management — June 2026"
              value={form.description}
              onChange={e => setField('description', e.target.value)}
              className={errors.description ? 'input-error' : ''}
            />
            {errors.description && <span className="field-error">{errors.description}</span>}
          </div>

          <div className="form-row">
            <div className="form-field">
              <label>Amount ($) <span className="required">*</span></label>
              <input
                type="number"
                min="0.01"
                step="0.01"
                placeholder="0.00"
                value={form.amountDue}
                onChange={e => setField('amountDue', e.target.value)}
                className={errors.amountDue ? 'input-error' : ''}
              />
              {errors.amountDue && <span className="field-error">{errors.amountDue}</span>}
            </div>

            <div className="form-field">
              <label>Due Date <span className="required">*</span></label>
              <input
                type="date"
                value={form.dueDate}
                onChange={e => setField('dueDate', e.target.value)}
                className={errors.dueDate ? 'input-error' : ''}
              />
              {errors.dueDate && <span className="field-error">{errors.dueDate}</span>}
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="btn-secondary" onClick={() => navigate(-1)}>Cancel</button>
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? 'Creating…' : 'Create Invoice'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
